module.exports = __webpack_public_path__ + "static/media/unassign.7d58e90c.svg";